import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-100 via-slate-200 to-slate-300 px-4">
      <div className="text-center space-y-6">
        <div className="text-7xl">🚫</div>
        <h1 className="text-5xl font-bold text-gray-800">404 - Page Not Found</h1>
        <p className="text-lg text-gray-600 max-w-md mx-auto">
          Sorry, the page <span className="font-mono">{location.pathname}</span> doesn’t exist.
        </p>
        <a
          href="/"
          className="inline-block bg-primary text-white font-semibold px-6 py-3 rounded-xl shadow hover:bg-primary-dark transition"
        >
          Go Back Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
